
<template>
  <div style="overlay">
    <iframe ref="contentFrame" src="/?actionMode=enable" frameborder="0" style="height: calc(100vh - 50px); width: 100vw; margin-bottom: -0.4rem"></iframe>
    <div class="d-flex" style="justify-content: center; text-align: center; background: rgb(20,20,20); height: 50px; padding-top: 7px;">
      <input
        v-model="queryText"
        @keyup.enter="btnSubmit()"
        type="text"
        :disabled="waiting"
        v-show="gameMounted"
        style="height: 36px;width: 200px; border: solid 1px rgb(150, 150, 150); padding-left:5px; color: rgb(150,150,150)"
      >
      <span style="width: 30px;"></span>
      <v-btn @click="btnSubmit()" :loading="waiting" v-show="gameMounted">
        送出
      </v-btn>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import uuid from 'short-uuid'
import _ from 'lodash'
import axios from '@/lib/axios'
const pbUtil = require('pb-util')

let sid = uuid.generate()

class STTEvent{
  constructor(data){
    this.type = 'payload'
    this.requestId = null
    // 從dialogflow 收到的data
    this.data = data
  }
}
class TTSMarkEvent{
  constructor(opts = {}){
    this.type = 'TtsEndpointEvent'
    this.index = 1
    this.numTts = 1
    this.ttsState = opts.name === 'START' ? 1 : opts.name === 'END' ? 2 : -1
    this.name = opts.name
  }
}

export default {
  data(){
    return {
      queryHistory: [],
      queryText: '',
      waiting: false,
      gameMounted: false
    }
  },
  mounted(){
    this.$onMessage = this.receiveMessage.bind(this)
    this.$store.commit('appbar/toggle', false)
    window.addEventListener('message', this.$onMessage, false)
    // this.$nextTick(()=>{
    //   console.log('test enable')
    //   this.$refs.contentFrame.contentWindow.postMessage({
    //     type: 'wordprison',
    //     event: 'dev_frame_setup'
    //   })
    // })
  },
  updated(){
    this.$store.commit('appbar/toggle', false)
  },
  beforeDestroy(){
    this.$store.commit('appbar/toggle', true)
    window.removeEventListener('message', this.$onMessage)
  },
  methods: {
    btnSubmit(){
      if(!this.waiting && this.queryText){
        let text = this.queryText
        this.waiting = true
        this.queryText = ''
        this.queryHistory.push(text)
        this.detectIntent(text)
          .then((response)=>{
            let result = null
            if(!response.data.webhookStatus || response.data.webhookStatus.code === 0){
              try{
                let payload = pbUtil.value.decode(response.data.queryResult.webhookPayload.fields.google)
                result = payload.richResponse.items.find((item) => item.htmlResponse).htmlResponse.updatedState
              }catch(e){
                throw new Error(`htmlResponse not found`)
              }
            }else{
              throw new Error(response.data.webhookStatus)
            }
            console.log(result)
            return result
          })
          .then((result)=>{
            console.log('postMessage')
            this.$refs.contentFrame.contentWindow.postMessage(new STTEvent(result))
          })
          .catch((e)=>{
            console.error(e)
          })
          .finally(()=>{
            this.waiting = false
          })
      }
    },
    detectIntent(text){
      // return axios.post(`http://localhost:7789/andy-self-test/us-central1/dialogflowProxy`, {
      return axios.post(`https://us-central1-andy-self-test.cloudfunctions.net/dialogflowProxy`, {
        sessionId: sid,
        queryInput: {
          text: {
            text,
            languageCode: 'zh-tw'
          }
        },
        queryParams: {
          timeZone: 'Asia/Taipei'
        }
      })
    },
    receiveMessage(event){
      if(event.data){
        let data = event.data
        if(data.type && (data.type.indexOf('webpack') > -1 || data.type === 'GetImmersiveApiLibUrl')){
          return
        }
        if(data.type === 'wordprison'){
          if(data.event === 'game.start'){
            this.gameMounted = true
            console.log('receive', data.event)
          }
        }
      }
      if(event.data && event.data.type){
        console.debug('parent-msg:', event.data.type, event)
      }else{
        console.debug('parent-msg:', event.data, event)
      }
    }
  }
}
</script>

<style>

</style>
